import React from 'react';
import PropTypes from 'prop-types';
import TextNodeContainer from './text-node';
import VideoNode from './video-node';
import ImageNode from './image-node';

const getDataFromNode = function(node) {
    return ['id', 'title'].reduce((data, key) => {
        return {...data, [key]: node.attr[key]};
    }, {});
};

class SlideNode extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            ...getDataFromNode(this.props.node),
            zIndex: props.zIndex
        };
        this.getListItems = this.getListItems.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.node !== nextProps.node) {
            this.setState({
                ...getDataFromNode(nextProps.node)
            });
        }
    }

    getListItems(node) {
        const {moduleURL = '', enableJREAppPlayerContainerButtons, disableJREAppPlayerContainerButtons,} = this.props;

        return node.children.map(n => {
            switch (n.name) {
                case 'text_node':
                    return <TextNodeContainer
                        key={n.attr.id}
                        node={n} />;
                case 'video_node':
                    return <VideoNode
                        moduleURL={moduleURL}
                        key={n.attr.id}
                        node={n}
                        requireAutoPlay={true}
                        enableJREAppPlayerContainerButtons={enableJREAppPlayerContainerButtons}
                        disableJREAppPlayerContainerButtons={disableJREAppPlayerContainerButtons}
                    />;
                case 'image_node':
                    return<ImageNode
                        moduleURL={moduleURL}
                        key={n.attr.id}
                        node={n}
                    />;
                default:
                    return null;
            }
        });
    }

    render() {
        return (
            <div className="slide-node">
                <div>
                    {this.getListItems(this.props.node)}
                </div>
            </div>
        );
    }
}

SlideNode.propTypes = {
    node: PropTypes.object.isRequired,
    moduleURL: PropTypes.string.isRequired,
};

export default SlideNode;



// WEBPACK FOOTER //
// ./src/js/components/app/jre/elements/slide-node.js